
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import PropTypes from 'prop-types';
import * as React from 'react';

import Typography from '@mui/material/Typography';
import PageTitle from '../../../components/PageTitle/PageTitle';
import ForwardingLetterUpload from './ForwardingLetterUpload';
import OtherLetterUpload from './OtherLetterUpload';
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function samePageLinkNavigation(event) {
  if (
    event.defaultPrevented ||
    event.button !== 0 || // ignore everything but left-click
    event.metaKey ||
    event.ctrlKey ||
    event.altKey ||
    event.shiftKey
  ) {
    return false;
  }
  return true;
}

function LinkTab(props) {
  return (
    <Tab
      component="a"
      onClick={(event) => {
        // Routing libraries handle this, you can remove the onClick handle when using them.
        if (samePageLinkNavigation(event)) {
          event.preventDefault();
        }
      }}
      aria-current={props.selected && 'page'}
      {...props}
    />
  );
}

LinkTab.propTypes = {
  selected: PropTypes.bool,
};


const IncomingLetterHome = () => {
    const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    // event.type can be equal to focus with selectionFollowsFocus.
    if (
      event.type !== 'click' ||
      (event.type === 'click' && samePageLinkNavigation(event))
    ) {
      setValue(newValue);
    }
  };
  return (
    <Box sx={{ width: '100%', alignItems:"center", display:"flex", flexDirection:"column"  }}>
        <PageTitle title="Incoming Letter Home" />
    <Paper sx={{  width: '60%', typography: 'body1', marginTop: 4, borderRadius: 2,boxShadow:"2px 2px 2px 2px gray"  }} >
    
      <Tabs
        value={value}
        onChange={handleChange}
        centered
        sx={{
        backgroundColor: '#ffffff', // Light gray
        borderRadius: 1, // Optional: rounded corners
        '& .MuiTabs-flexContainer': {
        justifyContent: 'center'
        }
    }}
      >
        <LinkTab label="Incoming Letter"/>
        <LinkTab label="Other Letter"/>
      </Tabs>
      <TabPanel value={value} index={0}>
        <ForwardingLetterUpload />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <OtherLetterUpload/>
      </TabPanel>
    </Paper>
    </Box>
  )
}

export default IncomingLetterHome